import classNames from 'classnames';
import React, { Fragment } from 'react';

import Icon from '@ant-design/icons';
import DotSvg from '@icons/dot.svg';

import styles from './styles/Display.less';

const hourFormat = 'HH:mm';
const dateFormat = 'MMM D';
const yearFormat = 'YYYY';

const renderInterval = (ts, withShortcut, withYear) => (
  <div className={styles.interval}>
    <div className={styles.date}>
      {!withShortcut ? <span className={styles.hour}>{ts.format(hourFormat)}</span> : null}
      <span className={styles.day}>{ts.format(dateFormat)}</span>
    </div>
    {withYear ? <span className={styles.year}>{ts.format(yearFormat)}</span> : null}
  </div>
);

const Display = ({ interval, shortcut, selected, title, className, showShortcut, expanded }) => {
  const classes = classNames(styles.display, className, { [styles.selected]: selected });
  const sameYear = interval[0].isSame(interval[1], 'year');
  return (
    <Fragment>
      {shortcut && shortcut === 'live' ? (
        <div className={styles.live}>
          Live
          <Icon component={DotSvg} />
        </div>
      ) : (
        <div className={classes}>
          {shortcut && showShortcut ? <div>{shortcut}</div> : null}
          <div className={styles.intervals}>
            {renderInterval(interval[0], showShortcut, !sameYear)}
            <div className={styles.to}>to</div>
            {renderInterval(interval[1], showShortcut, true)}
          </div>
          {(selected || expanded) && title ? <div className={styles.title}>{title}</div> : null}
        </div>
      )}
    </Fragment>
  );
};

Display.defaultProps = {
  selected: false,
  shortcut: '',
  title: 'Time Frame',
  className: '',
  showShortcut: false,
  expanded: false,
};

export default Display;
